<template>
  <slide-x-left-transition :duration="400+(index*50)" :delay="200+(index*50)">
    <ion-card v-if="show"
              mode="ios"
              :class="{ 'ion-activatable' : hasRedirect }"
              @click="redirect"
              style="margin: 0 0 10px 0px">
      <div class="item-notification" :class="{ 'no-image' : thumbnail == null }">
        <div v-if="thumbnail" class="image" style="height: 70px">
          <ion-img v-if="thumbnail" :src="thumbnail" :alt="title"/>
        </div>
        <div class="description">
          <div class="status" :class="isRead == false ? 'active' : 'inactive'">
            <span class="dot">
                <svg width="20" height="20" viewBox="0 0 20 20"><circle cx="10" cy="10" r="4.5"/></svg>
            </span>
            <span class="label" v-text="isRead == false ? 'Nowe' : 'Przeczytane'"></span>
            <div v-if="loading" class="loader-wrapper smaller"><span class="loader gold"></span></div>
            <span class="close" v-if="isRead == false && loading == false"
                  @click="dismissNotification($event, index, id)">
                <svg class="icon"><use :xlink:href="'#icon-close'"></use></svg>
            </span>
          </div>
          <div class="title"><strong>{{ title }}</strong></div>
          <div class="body" v-html="body"></div>
        </div>
      </div>
    </ion-card>
  </slide-x-left-transition>
</template>

<script>
  import {mapState} from 'vuex';
  import goTo from '@/mixins/goto';

  export default {
    name: 'ItemNotification',
    props: ['index', 'id', 'slug', 'title', 'body', 'thumbnail', 'isRead', 'hasRedirect', 'redirectRoute', 'redirectSlug'],
    mixins: [goTo],
    data() {
      return {
        show: false,
        loading: false
      }
    },
    computed: {
      ...mapState({
        notifications: state => state.profile.notifications
      })
    },
    mounted() {
      this.show = true;
    },
    methods: {
      redirect() {
        if (this.hasRedirect) {
          setTimeout(() => {
            console.log('notification hasRedirect')
            this.goTo(this.redirectRoute, this.redirectSlug ? this.redirectSlug : null)
          }, 200);
        }
      },
      dismissNotification(e, index, id) {
        e.stopPropagation(); // prevent redirect
        this.loading = true;
        this.$store.dispatch('profile/PROFILE_DISMISS_NOTIFICATION', id)
            .then(() => {
              this.loading = false;
              let value = {
                index: index,
                bool: true
              };
              this.$store.commit('profile/PROFILE_DISMISS_NOTIFICATION_SUCCESS', value)
            })
            .catch(() => {
              this.loading = false;
            });
      }
    }
  }
</script>